/**
 * Chargeur unique de l'application.
 *
 * Il y en avait deux : celui-ci, orange, posé par le découpage des routes, et
 * un rond rouge hérité de la première version. Une fiche produit les enchaînait
 * — orange le temps de charger son code, rouge le temps de charger ses données
 * — et l'écran semblait se charger deux fois. Un seul suffit, et il ne change
 * pas de couleur en cours de route.
 */
const AppLoader = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="h-8 w-8 rounded-full border-2 border-gray-200 border-t-orange-500 animate-spin" />
  </div>
);

export default AppLoader;
